export const testIds = {
  emptyState: 'data-testid empty-state',
  errorState: 'data-testid error-state',
  loadingState: 'data-testid loading-state',
};
